import { useMemo } from 'react'
import { SaleOrder } from '../../../../sales'
import { useStateHooks } from '../../../../../state'
import { TableName } from '../../../../../tables'
import { Product } from '../../../../products'
import { WidgetCard } from '../widget-card/widgetCard'
import { RoutePath } from '../../../../../features/routes'
import { isInRange, formatNumber } from '../../../utils/dashboardUtils'
import styles from './topRotationWidget.module.css'

type Props = {
    loading: boolean
    error: boolean
    sales: SaleOrder[]
}

export const TopRotationWidget = (props: Props) => {
    const { loading, error, sales } = props
    const { find } = useStateHooks()

    const topProducts = useMemo(() => {
        const ninetyDaysAgo = new Date()
        ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90)
        const startStr = `${ninetyDaysAgo.getFullYear()}-${String(ninetyDaysAgo.getMonth() + 1).padStart(2, '0')}-${String(ninetyDaysAgo.getDate()).padStart(2, '0')}`
        const todayStr = new Date().toISOString().split('T')[0]
        const range = { start: startStr, end: todayStr, label: '' }

        const recentSales = sales.filter(s => isInRange(s.creationDate, range))

        const unitsByProduct: Record<string, number> = {}
        recentSales.forEach(sale => {
            sale.items.forEach(item => {
                unitsByProduct[item.productId] = (unitsByProduct[item.productId] || 0) + item.quantity
            })
        })

        return Object.entries(unitsByProduct)
            .sort(([, a], [, b]) => b - a)
            .slice(0, 6)
            .map(([productId, units]) => {
                const product = find(TableName.PRODUCTS, productId) as Product | undefined
                return { productId, productName: product?.name || productId, units }
            })
    }, [sales])

    return (
        <WidgetCard
            title="Mayor rotación — últimos 90 días"
            loading={loading}
            error={error}
            empty={!loading && !error && topProducts.length === 0}
            linkLabel="Ver stock"
            linkPath={RoutePath.STOCK}
        >
            <div className={styles.header}>
                <span className={styles.headerRank} />
                <span className={styles.headerName} />
                <span className={styles.headerCol}>Vendido</span>
            </div>
            <ul className={styles.list}>
                {topProducts.map((p, idx) => (
                    <li key={p.productId} className={styles.item}>
                        <span className={styles.rank}>{idx + 1}</span>
                        <span className={styles.name}>{p.productName}</span>
                        <span className={styles.units}>{formatNumber(p.units)} ud.</span>
                    </li>
                ))}
            </ul>
        </WidgetCard>
    )
}
